import { GameScene } from '../GameScene';
import { ClientMessageType, type ItemTemplateListMessage } from '@shared/types/messages';

/**
 * Panel de dev de items (visor de templates): pide la lista de templates al server y la muestra.
 * Extraído de GameScene (god-object). El estado (itemPanel) y createItemPanel viven en GameScene y
 * se acceden vía `this.scene.*`.
 */
export class ItemPanelController {
  constructor(private scene: GameScene) {}

  public handleItemTemplateListMessage(message: ItemTemplateListMessage): void {
    if (this.scene.itemPanel) {
      this.scene.itemPanel.setTemplates(message.templates);
    }
  }

  public openItemPanel(): void {
    if (!this.scene.itemPanel) {
      this.scene.devPanels.createItemPanel();
    }
    this.scene.itemPanel.open();
    if (this.scene.itemPanel.getTemplates().length === 0) {
      this.requestItemTemplates();
    }
  }

  public closeItemPanel(): void {
    this.scene.itemPanel?.close();
  }

  public toggleItemPanel(): void {
    if (!this.scene.itemPanel) {
      this.scene.devPanels.createItemPanel();
    }
    const wasOpen = this.scene.itemPanel.isOpenPanel();
    this.scene.itemPanel.toggle();
    if (!wasOpen && this.scene.itemPanel.isOpenPanel() && this.scene.itemPanel.getTemplates().length === 0) {
      this.requestItemTemplates();
    }
  }

  public requestItemTemplates(): void {
    if (!this.scene.colyseusClient) return;

    this.scene.colyseusClient.send({
      type: ClientMessageType.REQUEST_ITEM_TEMPLATES,
    } as never);
  }
}
